import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    * {
        box-sizing: border-box;
    }

    body {
        margin: 0;
        padding: 0;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -webkit-touch-callout: none;
        -ms-scroll-snap-coordinate: 0 0;
        scroll-snap-coordinate: 0 0;
        -ms-scroll-snap-type: mandatory;
        scroll-snap-type: mandatory;
        -webkit-overflow-scrolling: touch;
        user-select: none;
        overflow: hidden;
        position: fixed !important;
        overscroll-behavior-x: none !important;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgb(19, 189, 239);
    }

    a {
        padding: 0;
        margin: 0;
        border: none;
        font-weight: bold;
        text-decoration: none;
        transition: background-color 150ms linear,color 150ms linear;

        &:focus {
            outline: none;
        }
    }

    #root {
        position: relative;
        z-index: 1;
    }

    h1,h2,h3,h4,h5,h6 {
        font-weight: 500;
    }

    h1 {
        font-size: 1.5em;
        line-height: 2.5em;
    }

    h2   {
        font-size: 1.25em;
        line-height: 2.1875em;
    }
    
    .iiz {
      margin: 0;
      position: relative;
      overflow: hidden;
      display: inline-block;
      cursor: zoom-in;
    }
    
    .iiz__img {
      max-width: 100%;
      height: auto;
      display: block;
      pointer-events: none;
      visibility: visible;
      opacity: 1;
    }
    
    .iiz__img--invisible {
      visibility: hidden;
      opacity: 0;
    }
    
    .iiz__zoom-img {
      width: auto !important;
      max-width: none !important;
      position: absolute;
      visibility: hidden;
      opacity: 0;
      display: block;
    }
    
    .iiz__zoom-img--visible {
      visibility: visible;
      opacity: 1;
      cursor: zoom-out;
    }
    
    .iiz__zoom-portal {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 10000;
    }
    
    .iiz__hint {
      bottom: 10px;
      right: 10px;
      pointer-events: none;
    }
    
    .iiz__hint:before {
      content: " ";
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19.9 19.9'%3E%3Cpath d='M13.9 7.4C13.9 3.8 11 .9 7.4.9S.9 3.8.9 7.4s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5zm5.3 12.5l-6.7-7.2c-1.4 1.3-3.2 2.1-5.1 2.1-4.1 0-7.4-3.3-7.4-7.4S3.3 0 7.4 0s7.4 3.3 7.4 7.4c0 1.7-.6 3.4-1.7 4.7l6.8 7.2-.7.6z' fill='%23000222'/%3E%3C/svg%3E");
      width: 20px;
      height: 20px;
    }
    
    .iiz__close {
      top: 10px;
      right: 10px;
      visibility: hidden;
      opacity: 0;
    }
    
    .iiz__close--visible {
      visibility: visible;
      opacity: 1;
    }
    
    .iiz__close::before {
      content: " ";
      width: 29px;
      height: 29px;
      background-image: linear-gradient(#222, #222), linear-gradient(#222, #222);
      background-size: 100% 1px, 1px 100%;
      transform: rotate(45deg);
    }
`;
